export default __webpack_public_path__ + "static/media/HEN_NOISE.51019d4a.wav";